<template>
    <transition name="fade" mode="out-in">
        <router-view v-if="online"/>

        <template v-else>
            <div class="d-flex h-100 w-100 flex-column">
                <b-overlay class="flex-fill d-flex align-items-center justify-content-center flex-column" :show="show">
                    <h4>
                        {{t('You are offline')}}
                    </h4>

                    <b-button class="bg-grad" @click="reload">
                        <span class="mx-1">{{t('Reload')}}</span>
                        <b-icon-arrow-repeat></b-icon-arrow-repeat>
                    </b-button>
                </b-overlay>
            </div>
        </template>
    </transition>
</template>

<style lang="scss">
</style>

<script>
    export default {
        name: "App",
        data: () => ({
            online: true,
            show: false
        }),
        methods: {
            onlineStatusHandler() {
                this.online = navigator.onLine
            },

            reload() {
                this.show = true
                setTimeout(() => {
                    this.onlineStatusHandler()
                    this.show = false;
                }, 1000)
            }
        },
        mounted() {
            this.onlineStatusHandler();

            window.addEventListener('offline', this.onlineStatusHandler)
            window.addEventListener('online', this.onlineStatusHandler)
        },
        beforeDestroy() {
            window.removeEventListener('offline', this.onlineStatusHandler);
            window.removeEventListener('online', this.onlineStatusHandler);
        }
    }
</script>
